// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.progressLoader {
  position: fixed;
  top: 0;
  width: 100%;
  height: 4px;
  z-index: 10000;
}
.progressLoader .paginate-loader {
  height: 4em;
  display: block;
  line-height: 4em;
  text-align: center;
  position: relative;
}
.progressLoader .paginate-loader:before {
  content: " ";
  position: absolute;
  overflow-y: hidden;
  top: 0;
  left: 0;
  width: 20%;
  height: 3px;
  background: #00d1b2;
  animation: loader-animation 2s ease-out infinite;
}

@keyframes loader-animation {
  0% {
    transform: translate(0%);
  }
  100% {
    transform: translate(500%);
  }
}`, "",{"version":3,"sources":["webpack://./src/app/loader/loader.component.scss"],"names":[],"mappings":"AA0BA;EACI,eAAA;EACA,MAAA;EACA,WAAA;EACA,WAAA;EACA,cAAA;AAzBJ;AA2BI;EACI,WAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;AAzBR;AA2BI;EACE,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,UAAA;EACA,WAAA;EACA,mBAAA;EACA,gDAAA;AAzBN;;AA8BA;EACI;IACE,wBAAA;EA3BJ;EA6BE;IACE,0BAAA;EA3BJ;AACF","sourcesContent":["// .progressLoader {\n//     position: fixed;\n//     top: 0;\n//     width: 100%;\n//     height: 4px;\n//     z-index: 10000;\n//     .progress {\n//         position: relative;\n//         width: 100%;\n//         height: 4px;\n//         // transition: width 2s;\n//     }\n// }\n\n// .spinner {\n//     position: fixed;\n//     top: 70px;\n//     right: 6%;\n//     height: 100px;\n//     z-index: 100000;\n//     .fa-spin {\n//         font-size: 28px !important;\n//     }\n// }\n\n\n.progressLoader {\n    position: fixed;\n    top: 0;\n    width: 100%;\n    height: 4px;\n    z-index: 10000;\n\n    .paginate-loader {\n        height: 4em;\n        display: block;\n        line-height: 4em;\n        text-align: center;\n        position: relative;\n    }\n    .paginate-loader:before {\n      content: ' ';\n      position: absolute;\n      overflow-y: hidden;\n      top: 0;\n      left: 0;\n      width: 20%;\n      height: 3px;\n      background: #00d1b2;\n      animation: loader-animation 2s ease-out infinite;\n    }    \n\n}\n\n@keyframes loader-animation {\n    0% {\n      transform: translate(0%);\n    }\n    100% {\n      transform: translate(500%);\n    }\n  }\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
